import { ShieldCheck } from "lucide-react";
import { SITE } from "../lib/site";

export const AnnouncementBar = () => (
  <div
    data-testid="announcement-bar"
    className="fixed top-0 inset-x-0 z-[60] w-full bg-[#FF3B30] text-white text-[11px] md:text-xs font-bold uppercase tracking-[0.25em] h-8 px-4 flex items-center justify-center gap-3"
  >
    <ShieldCheck className="w-3.5 h-3.5" strokeWidth={2.5} />
    <span className="flex items-baseline gap-2">
      <span className="hidden sm:inline text-white/80">// New</span>
      <span>Now offering a {SITE.warranty.months}-month / {SITE.warranty.miles.toLocaleString()}-mile warranty on every job</span>
    </span>
  </div>
);

export default AnnouncementBar;
